import { createFileRoute } from '@tanstack/react-router'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { DrawingSearchForm } from '@/src/components/manage/forms/DrawingSearchForm'

export const Route = createFileRoute('/_manage/manage/drawings/search')({
  component: SearchDrawingsPage,
})

function SearchDrawingsPage() {
  return (
    <div className="bg-background text-foreground">
      <AdminToolbar>
        <AdminToolbar.BackButton to="/manage/drawings" />
      </AdminToolbar>
      <div className="mt-4">
        <DrawingSearchForm />
      </div>
    </div>
  )
}
